import React from "react";
import * as XLSX from "xlsx";
import { FiRefreshCw } from "react-icons/fi";
import Lozenge from "../../../../components/BaseUI/Lozenge";
import {
  dateStrInAppTz,
  dayBoundsInAppTz,
  formatDateTimeTrInAppTz,
  formatInstantDateShortTr,
} from "../../../../utils/appTime";

// ── Date helpers ──────────────────────────────────────────────────────────────
export const pad = (n) => String(n).padStart(2, "0");

export const todayStr = () => dateStrInAppTz(new Date());

export const monthStartStr = () => {
  const s = dateStrInAppTz(new Date());
  const [y, m] = s.split("-");
  return `${y}-${m}-01`;
};

export const MONTHS_TR = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
];

export const salesMonthLabelTr = (monthIndex, year) =>
  `${MONTHS_TR[monthIndex] ?? "—"} ${year}`;

/** API range: Istanbul calendar day → UTC ISO bounds. */
export const toISO = (s, isEnd) => {
  const ds = String(s).trim().slice(0, 10);
  const b = dayBoundsInAppTz(ds);
  return (isEnd ? b.end : b.start).toISOString();
};

// ── Formatters ────────────────────────────────────────────────────────────────
export const fmtDate = (d) => (d ? formatInstantDateShortTr(d) : "—");
export const fmtDT = (d) => (d ? formatDateTimeTrInAppTz(d) : "—");
export const fmtPct = (v) => (v == null ? "—" : `${v}%`);
export const fmtMins = (m) => {
  if (m == null) return "—";
  const total = Math.round(Number(m));
  const h = Math.floor(total / 60);
  const min = total % 60;
  return h > 0 ? `${h}s ${min}dk` : `${min}dk`;
};

export const oeeAppearance = (v) =>
  v == null
    ? "default-subtle"
    : v >= 80
      ? "success-subtle"
      : v >= 60
        ? "warning-subtle"
        : "danger-subtle";

// ── Excel export ──────────────────────────────────────────────────────────────
export const exportXLSX = (rows, filename, sheet = "Rapor") => {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheet);
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

// ── Shared UI components ──────────────────────────────────────────────────────
export const KpiCard = ({ label, value, sub, referenceColor }) => (
  <div className="card card-body rp-kpi-card p-1">
    <p className="rp-kpi-card__label mb-1">
      {referenceColor ? (
        <span
          className="rp-kpi-card__ref-dot"
          style={{ backgroundColor: referenceColor }}
          aria-hidden
        />
      ) : null}
      <span>{label}</span>
    </p>
    <h4 className="rp-kpi-card__value mb-0">{value ?? "—"}</h4>
    {sub && (
      <div className="rp-kpi-card__sub text-muted small mb-0 mt-1">{sub}</div>
    )}
  </div>
);

export const SectionSpinner = () => (
  <div className="rp-section-state rp-section-state--loading">
    <FiRefreshCw className="rp-spin" size={26} aria-hidden />
    <span className="text-muted small">Yükleniyor…</span>
  </div>
);

export const SectionEmpty = ({
  msg = "Bu tarih aralığında veri bulunamadı.",
}) => (
  <div className="rp-section-state rp-section-state--empty">
    <span className="text-muted">{msg}</span>
  </div>
);
